<template>
    <div class="container-fluid no-scroll">
      <div class="row overflow-scroll">
        <!-- Your dynamic divs go here -->
        <div
          v-for="option in options.slice(0,4)"
          :key="option.id"
          class="col-xs-8 col-sm-4 col-md-3 col-lg-2 mb-2n attr"
          style="padding-left: 0.8em; padding-right: 0.8em;"
          @click="goToEventDetail(option)"
        >
          <div class="card borderless" style="border: none">
            <!--width fit content-->
            <div
              class="card-body"
              style="
                text-align: center;
                padding-bottom: 0px;
                padding-top: 0.1em;
              "
            >
              <!-- Content for each div -->
              <!--<h5 class="card-title">{{ item.title }} option.class1,</h5>-->
              <router-link
                to="/attractions"
                class="col-5 align-items-center topic me-2"
                style="
                  position: relative;
                  height: fit-content;
                  width: 42%;
                  margin-top: 1em;
                  text-align: left;
                "
              >
                <img
                  :src="option.image"
                  :alt="option.altText"
                  class="img-fluid"
                  style="margin-top: 10px; border-radius: 8px; width: 184px !important;height: 96px !important;"
                />
                <p
                  class="m-0 cat-text"
                  style="font-weight: 600; margin-top: 0.5em !important; margin-bottom:0 !important; color: #030c12"
                >
                  {{ option.title }}
                </p>
                <div style="display: flex; align-items: center">
                  <i
                    class="['bi', 'me-2']"
                    style="
                      font-size: 1rem;
                      margin: 0px !important;
                      color: #2f6787;
                      width: 24px;
                      height: 24px;
                    "
                  >
                  <svg
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2131_9143)">
                            <g clip-path="url(#clip1_2131_9143)">
                              <path
                                d="M7 7.75C5.965 7.75 5.125 6.91 5.125 5.875C5.125 4.84 5.965 4 7 4C8.035 4 8.875 4.84 8.875 5.875C8.875 6.91 8.035 7.75 7 7.75ZM7 4.75C6.38125 4.75 5.875 5.25625 5.875 5.875C5.875 6.49375 6.38125 7 7 7C7.61875 7 8.125 6.49375 8.125 5.875C8.125 5.25625 7.61875 4.75 7 4.75Z"
                                fill="#2F6787"
                              />
                              <path
                                d="M6.99984 12.25L3.83485 8.51875C3.8161 8.49625 3.70359 8.34999 3.70359 8.34999C3.15984 7.62624 2.87109 6.77125 2.87109 5.875C2.87109 3.6025 4.71984 1.75 6.99609 1.75C9.27234 1.75 11.1211 3.6025 11.1211 5.875C11.1211 6.77125 10.8323 7.62624 10.2923 8.34999C10.2923 8.34999 10.1798 8.5 10.1648 8.51875L6.99984 12.25ZM4.3036 7.89624C4.3036 7.89624 4.38984 8.01249 4.41234 8.03499L6.99984 11.0875L9.59109 8.03125C9.60609 8.00875 9.69609 7.89625 9.69609 7.8925C10.1423 7.30375 10.3748 6.6025 10.3748 5.87125C10.3748 4.01125 8.85984 2.49625 6.99984 2.49625C5.13984 2.49625 3.62484 4.01125 3.62484 5.87125C3.62484 6.60625 3.8611 7.30375 4.3036 7.8925V7.89624Z"
                                fill="#2F6787"
                              />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_2131_9143">
                              <rect width="13" height="13" fill="white" />
                            </clipPath>
                            <clipPath id="clip1_2131_9143">
                              <rect
                                width="13"
                                height="12"
                                fill="white"
                                transform="translate(0 1.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                    <!-- SVG icon code here -->
                  </i>
                  <p
                    style="
                      margin-left: 10px !important;
                      margin-bottom: 0px;
                      font-size: 11px;
                      color: #2f6787;
                      font-weight: 600;
                      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                    "
                  >
                  <!-- white-space: initial !important;-->
                    {{ option.address }}
                  </p>
                </div>
                <div style="display: flex; align-items: center" v-if="hasPaymentInfo">
                  <i
                    :class="['bi', 'me-2']"
                    style="
                      font-size: 1rem;
                      margin: 0px !important;
                      color: #2f6787;
                      width: 24px;
                      height: 24px;
                    "
                  >
                  <svg
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2131_9151)">
                            <path
                              d="M12.6919 5.125C12.9325 5.125 13.1294 4.92812 13.1294 4.6875V2.5C13.1294 2.01875 12.7356 1.625 12.2544 1.625H1.75439C1.27314 1.625 0.879395 2.01875 0.879395 2.5V4.6875C0.879395 4.92812 1.07627 5.125 1.31689 5.125C1.79814 5.125 2.19189 5.51875 2.19189 6C2.19189 6.48125 1.79814 6.875 1.31689 6.875C1.07627 6.875 0.879395 7.07188 0.879395 7.3125V9.5C0.879395 9.98125 1.27314 10.375 1.75439 10.375H12.2544C12.7356 10.375 13.1294 9.98125 13.1294 9.5V7.3125C13.1294 7.07188 12.9325 6.875 12.6919 6.875C12.2106 6.875 11.8169 6.48125 11.8169 6C11.8169 5.51875 12.2106 5.125 12.6919 5.125ZM12.2544 7.69312V9.5H9.19189V8.1875H8.31689V9.5H1.75439V7.69312C2.50689 7.50062 3.06689 6.81375 3.06689 6C3.06689 5.18625 2.50689 4.49938 1.75439 4.30688V2.5H8.31689V3.8125H9.19189V2.5H12.2544V4.30688C11.5019 4.50375 10.9419 5.18625 10.9419 6C10.9419 6.81375 11.5019 7.50062 12.2544 7.69312Z"
                              fill="#2F6787"
                            />
                            <path
                              d="M9.19189 4.6875H8.31689V7.3125H9.19189V4.6875Z"
                              fill="#2F6787"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2131_9151">
                              <rect
                                width="13"
                                height="12"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                    <!-- SVG icon code here -->
                  </i>
                  <p
                    style="
                      margin: 0px !important;
                      font-size: 11px;
                      color: #2f6787;
                      font-weight: 600;
                    "
                    
                  >
                    {{ option.price }}
                  </p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AttractionsScrollComponent',
    props: {
      options: {
        type: Array,
        required: true
      }
    },
    methods: {
    goToEventDetail(item) {
      console.log("teste");
      console.log("item is ", item);
      // Use router.push to navigate to EventDetail route with state
      this.$router.push({
        name: "AttractionDetail",
        params: { itemData: JSON.stringify(item) },
      });
    },
  },
  };
  </script>
  
  <style scoped>
  /* Add your component-specific styles here */
  .card-body {
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                    
  
  
  }
  </style>
  